import React, { useMemo } from 'react';
import qrcode from 'qrcode-generator';

/**
 * Render a string as an SVG QR code.
 *
 * Drawn as a single `<path>` from the module matrix rather than through a
 * canvas: it stays sharp at any size, prints correctly, and needs nothing at
 * runtime. Error correction "M" tolerates a fingerprint on the screen; the
 * 2-module quiet zone is what actually lets a phone lock onto it.
 */
export default function QrCode({ value, size = 208, title }) {
  const model = useMemo(() => {
    if (!value) return null;
    const qr = qrcode(0, 'M'); // type 0 = pick the smallest that fits
    qr.addData(value);
    qr.make();
    const count = qr.getModuleCount();
    const cells = [];
    for (let row = 0; row < count; row += 1) {
      for (let col = 0; col < count; col += 1) {
        if (qr.isDark(row, col)) cells.push(`M${col} ${row}h1v1h-1z`);
      }
    }
    return { path: cells.join(''), box: count + 4 };
  }, [value]);

  if (!model) return null;

  return (
    <svg
      className="qr-code"
      viewBox={`-2 -2 ${model.box} ${model.box}`}
      width={size}
      height={size}
      role="img"
      aria-label={title || 'QR code'}
      shapeRendering="crispEdges"
    >
      <rect x="-2" y="-2" width={model.box} height={model.box} fill="#ffffff" />
      <path d={model.path} fill="#0f172a" />
    </svg>
  );
}
